var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rect',{staticClass:"selection-box",style:(_vm.style),attrs:{"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height},on:{"mousedown":function($event){$event.preventDefault();return _vm.$emit('mousedown', $event);}}})}
var staticRenderFns = []

export { render, staticRenderFns }